export default __webpack_public_path__ + "static/media/KonnectzIt.ffe88b2d.svg";